(function(){
  function boot(){
    if(!('IntersectionObserver' in window)){
      document.querySelectorAll('.vibes .rv').forEach(function(e){e.classList.add('in')});
      return;
    }
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})
    },{threshold:.1,rootMargin:'0px 0px -30px 0px'});
    document.querySelectorAll('.vibes .rv:not(.in)').forEach(function(el,i){
      el.style.transitionDelay=(i%3*70)+'ms'; io.observe(el);
    });
  }
  if(document.readyState!=='loading'){boot()}else{document.addEventListener('DOMContentLoaded',boot)}
  document.addEventListener('shopify:section:load',boot);
})();
